import FOML from './portfolio_photos/FOML.png';
import PAA from './portfolio_photos/PAA.png';
import DF from './portfolio_photos/Deepfake.png';
import VMPS from './portfolio_photos/VMPS.png';
import RCM from './portfolio_photos/RCM.png';


export const techStack = [

  { name: "Python", link: "https://img.icons8.com/color/48/python--v1.png", alt:"python" },
  { name: "Bash", link: "https://img.icons8.com/?size=100&id=19292&format=png&color=000000", alt: "bash" },
  { name: "NodeJS", link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original-wordmark.svg" },
  { name: "Java", link: "https://img.icons8.com/?size=100&id=13679&format=png&color=000000", alt:"Java" },
  { name: "Javascript", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" },
  { name: "Docker", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-plain.svg" },
  { name: "Kubernetes", link: "https://img.icons8.com/?size=100&id=cvzmaEA4kC0o&format=png&color=000000", alt:"Kubernetes"},
  
  { name: "Git", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-plain.svg" },
  { name: "Ansible", link: "https://img.icons8.com/?size=100&id=iGCCE2iEmh2u&format=png&color=000000", alt:"Ansible" },
  { name: "HTML", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg" },
  { name: "React", link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg" },
  { name: "CSS", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-plain.svg" },
  { name: "C++", link: "https://img.icons8.com/color/48/c-plus-plus-logo.png", alt:"c-plus-plus"},

  // { name: "npm.js", link: "https://img.icons8.com/color/480/npm.png", alt:"npm" },
  // { name: "SQL", link: "https://img.icons8.com/ios/100/sql.png", alt:"sql" },
  // { name: "MS SQL Server", link: "https://img.icons8.com/color/480/microsoft-sql-server.png", alt:"microsoft-sql-server" },
  // { name: "Explainable AI (XAI)", link: "https://img.icons8.com/plasticine/100/ai.png", alt:"ai" },
  // { name: "Anaconda", link: " https://img.icons8.com/fluency/240/anaconda--v2.png", alt:"anaconda--v2" },

  { name: "MySQL", link: "https://www.vectorlogo.zone/logos/mysql/mysql-ar21.svg", alt:"mysql" },
  { name: "Mongo DB", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-plain.svg" },
  { name: "PostgreSQL", link: "https://www.vectorlogo.zone/logos/postgresql/postgresql-vertical.svg", alt:"postgresql" },
  { name: "Neo4j", link: "https://www.vectorlogo.zone/logos/neo4j/neo4j-ar21.svg", alt:"neo4j" },


  { name: "Big Data", link: "https://img.icons8.com/ios-filled/100/big-data.png", alt:"big-data" }, 
  { name: "Hadoop", link: "https://img.icons8.com/color/480/hadoop-distributed-file-system.png", alt:"hadoop-distributed-file-system" },
  { name: "Apache Spark", link: "https://www.vectorlogo.zone/logos/apache_spark/apache_spark-ar21.svg", alt:"apache-spark" },
  { name: "Kakfa", link: "https://www.vectorlogo.zone/logos/apache_kafka/apache_kafka-ar21.svg", alt:"kafka" },
  { name: "AWS", link: "https://img.icons8.com/color/480/amazon-web-services.png", alt:"amazon-web-services" },


  { name: "Power BI", link: "https://img.icons8.com/color/480/power-bi.png", alt:"power-bi" },
  { name: "Tableau", link: "https://img.icons8.com/color/480/tableau-software.png", alt:"tableau-software" },
  { name: "Excel", link: "https://img.icons8.com/color/480/microsoft-excel-2019--v1.png", alt:"microsoft-excel-2019--v1" },

  
  { name: "NumPy", link: "https://img.icons8.com/color/480/numpy.png", alt:"numpy" },
  { name: "Pandas", link: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ed/Pandas_logo.svg/1200px-Pandas_logo.svg.png" },
  { name: "Matplotlib", link: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Created_with_Matplotlib-logo.svg/2048px-Created_with_Matplotlib-logo.svg.png" },
  { name: "scikit-learn", link: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Scikit_learn_logo_small.svg/1200px-Scikit_learn_logo_small.svg.png" },
  { name: "PyTorch", link: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/PyTorch_logo_icon.svg/640px-PyTorch_logo_icon.svg.png" },
  
  { name: "Machine Learning", link: "https://img.icons8.com/stickers/100/artificial-intelligence.png", alt:"artificial-intelligence" },
  { name: "Deep Learning", link: "https://img.icons8.com/external-becris-lineal-becris/64/external-deep-learning-artificial-intelligence-becris-lineal-becris.png", alt:"deep-learning" },
  { name: "Jupyter", link: "https://img.icons8.com/fluency/240/jupyter.png", alt:"jupyter" },
  { name: "Generative AI", link: "https://img.icons8.com/nolan/256/chatgpt.png", alt:"chatgpt"},
  { name: "Selenium", link: "https://img.icons8.com/stickers/400/selenium-test-automation.png", alt:"selenium-test-automation" },
  { name: "Tailwind CSS", link: "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg" },
]

export const contactLinks = [
  { name: 'LinkedIn', url1: 'https://img.icons8.com/color/48/linkedin.png', url2: 'https://img.icons8.com/color/48/linkedin.png', link: "https://www.linkedin.com/in/shubhang-kalkar/"},
  { name: 'Github', url1: 'https://img.icons8.com/sf-regular-filled/48/github.png', url2: "https://img.icons8.com/material-outlined/48/FFFFFF/github.png", link :'https://github.com/ShubhangKalkar'},
  { name: 'Email', url1: 'https://img.icons8.com/?size=100&id=P7UIlhbpWzZm&format=png&color=000000', url2: "https://img.icons8.com/bubbles/48/new-post.png", link :"mailto:shubhangkalkar10@gmail.com"}
]

export const projects = [
  { 
    name: 'Personal AI Assistant',
    link: "https://github.com/ShubhangKalkar/Personal-AI-Assistant",
    gitlink: "https://github.com/ShubhangKalkar/Personal-AI-Assistant",
    desc: "A smart AI-powered assistant that automates tasks like scheduling, answering queries, and managing information through natural language interactions.",
    img: PAA, 
    tech: ["Python", "LLMs", "OpenAI", "Pinecone", "Fine-tuning"]
  },  
  { 
    name: "DeepFake: Detection and Generation",
    link: 'https://github.com/ShubhangKalkar/DeepFake-Detection',
    gitlink: 'https://github.com/ShubhangKalkar/DeepFake-Detection',
    desc: "Leveraging deep learning and computer vision, this project identifies DeepFake media by training convolutional neural networks (CNNs) on facial inconsistencies, texture artifacts, and visual anomalies.",
    img: DF,
    tech: ["Python", "First-Order-Motion-Model", "Wav2Lip", "Django", "SVTTS", "NLP", "Machine Learning"]
  },
  { 
    name: 'Resume Classifier',
    link: "https://github.com/ShubhangKalkar/Resume-Classification",
    gitlink: "https://github.com/ShubhangKalkar/Resume-Classification",
    desc: "This project develops a machine learning model to classify resumes into categories based on the job descriptions. It utilizes several algorithms like Support Vector Machine (SVM), Multinomial Naive Bayes, Random Forest, and DistilBERT to achieve this.",
    img: 'https://img.freepik.com/premium-vector/remote-recruitment-colorful-flat-illustration_1168412-484.jpg?w=1380', 
    tech: ["Python", "Selenium", "Scikit-learn", "Matplotlib", "Pandas", "SVM", "Random Forest", "Naive Bayes", "Machine Learning"]
  },
  { 
    name: "Realtime Voting Analysis",
    link: 'https://github.com/ShubhangKalkar/Real-Time-Voting-Analysis',
    gitlink: 'https://github.com/ShubhangKalkar/Real-Time-Voting-Analysis',
    desc: "This project aims to simulate a real-world election scenario where votes are cast, processed, and visualized in real-time. Leveraging modern technologies built a robust, scalable, and live-updating voting platform.",
    img: 'https://img.freepik.com/premium-photo/hand-putting-vote-ballot-box-against-american-flag-background-presidential-election-usa_89223-6550.jpg?w=2000',
    tech: ["Python", "Docker", "PostgreSQL", "Kafka", "Apache Spark", "Streamlit", "Min Hashing", "Shingling", "K-Anonymity"]
  },
  { 
    name: "Github Code Summarization using LLM",
    link: 'https://github.com/ShubhangKalkar/Code-Summarization-using-LLM-LangChain',
    gitlink: 'https://github.com/ShubhangKalkar/Code-Summarization-using-LLM-LangChain',
    desc: "Implemented features for interactive querying, tokenizing queries, and finding matches to enhance repository comprehension and exploration. Explore and ask questions about a GitHub code repository using OpenAI's GPT-3 language model.",
    img: 'https://img.freepik.com/free-vector/programmer-working-web-development-code-engineer-programming-python-php-java-script-computer_90220-250.jpg?t=st=1722406991~exp=1722410591~hmac=ed8bb049d1e52cc041943a2f0cedd24d17073b414da62bacf70551d31af35088&w=1480',
    tech: ["Python", "LLM", "OpenAI", "Tokenization"]
  },
  { 
    name: "Vehicle Monitoring and Parking Solution",
    link: 'https://github.com/ShubhangKalkar/Vehicle-Monitoring_and-Parking-Solution',
    gitlink: 'https://github.com/ShubhangKalkar/Vehicle-Monitoring_and-Parking-Solution',
    desc: "A smart vehicle monitoring and parking management system that leverages YOLO-based object detection and OCR techniques to detect vehicles, read license plates, track entries/exits, and optimize parking lot usage.",
    img: VMPS,
    tech: ["JavaScript", "Node.js", "MySQL", "HTML", "CSS", "YOLO", "OCR", "Django"]
  },
  { 
    name: "First Order Motion Model",
    link: 'https://github.com/ShubhangKalkar/first-order-motion-model',
    gitlink: 'https://github.com/ShubhangKalkar/first-order-motion-model',
    desc: "An implementation of a First-Order Motion Model for unsupervised image animation, leveraging convolutional neural networks (CNNs) and dense motion fields to transfer motion from a driving video to a source image.",
    img: FOML,
    tech: ["Machine Learning", "Wav2Lip", "Driving Image", "Driven Image", "HTML", "CSS"]
  },
  { 
    name: "Clover Payment Gateway - Revenue Cycle Management",
    link: 'https://github.com/ShubhangKalkar/Basic-Payment-Workflow-Using-Clover-Payment-Gateway',
    gitlink: 'https://github.com/ShubhangKalkar/Basic-Payment-Workflow-Using-Clover-Payment-Gateway',
    desc: "A full-stack Node.js app that simulates a Clover payment workflow using OAuth2, real-time order creation, and test card transactions via the Clover Developer Sandbox.",
    img: RCM,
    tech: ["HTML", "CSS", "JavaScript", "Node.js", "Express.js", "OAuth2"]
  }
]
   
export const skill = [
  {
    name: 'Software Development',
    desc: "Skilled in building scalable backend systems, optimizing code quality, and driving reliable software development practices."
  },
  {
    name: 'Data Engineering',
    desc: "Experienced in designing cloud-based data pipelines, automating ETL workflows, and enabling real-time data solutions."
  },
  {
    name: 'Full Stack',
    desc: "Capable of delivering complete web applications by combining efficient backend architecture with intuitive frontend experiences."
  }


]